import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';

import { Typography } from '../../../../components/Wrappers/Wrappers';
import CtaButton from '../../../../commons/ctaButton';
import { useStyles } from './integrationsSection.styles';
import Logo from './Logo';

function IntegrationDetailsDialog ({ integration, open, onClose }) {
    const classes = useStyles();
    const { name, category, description, subtitle, summary, features } = integration;
    const bodyText = summary || description;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <div className={classes.modal}>
                <div className={classes.modalHeader}>
                    <Logo integration={integration} />
                    <div>
                        <Typography variant="h6" weight="bold">{name}</Typography>
                        {category && <span className={classes.cardCat}>{category}</span>}
                    </div>
                </div>

                {subtitle && (
                    <Typography variant="body2" className={classes.modalSubtitle}>{subtitle}</Typography>
                )}

                {bodyText && (
                    <Typography variant="body2" className={classes.modalBody}>{bodyText}</Typography>
                )}

                {features && features.length > 0 && (
                    <ul className={classes.features}>
                        {features.map((feature) => (
                            <li key={feature} className={classes.feature}>
                                <CheckIcon className={classes.checkIcon} />
                                <Typography variant="body2">{feature}</Typography>
                            </li>
                        ))}
                    </ul>
                )}

                <CtaButton kind="primary" fullWidth onClick={onClose}>
                    Close
                </CtaButton>
            </div>
        </Dialog>
    );
}

IntegrationDetailsDialog.propTypes = {
    integration: PropTypes.shape({
        name: PropTypes.string,
        category: PropTypes.string,
        description: PropTypes.string,
        subtitle: PropTypes.string,
        summary: PropTypes.string,
        features: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default IntegrationDetailsDialog;
